import { isNil } from 'lodash';
import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Box } from '~ui-kit/components/box/box';
import { styled } from '~ui-kit/styled-components';
import { LoginPage } from '~web-portal/modules/login';
import { ModifyPolicyPage, PoliciesPage, PolicyDocumentsPage } from '~web-portal/modules/policies';
import { ProfilePage } from '~web-portal/modules/profile';
import { useAuthStore } from '~web-portal/stores';
import { Paths } from '~web-portal/variables/paths';
import { NotFoundPage } from './not-found-page/not-found-page';
import { PrivateRoute } from './private-route';

export function AppContainer() {
  const translator = useTranslator();
  const isLoggedIn = useAuthStore.use.isLoggedIn();

  useEffect(() => {
    // Check if i18n lng parameter exists in query
    const params = new RegExp('lng=([^&]*)').exec(location.href);

    // If exists, update language and remove it from query
    if (!isNil(params) && params.length >= 2) {
      // Update app language
      void translator.changeTranslatorLanguage(params[1]);
      const query = location.href.replace(new RegExp(`lng=([^&]*)&?`), '');
      // Replacing state change url without reloading the browser. If user changes language (which trigger
      // a reload), the initial query language will not update i18n
      window.history.replaceState(null, null, query);
    }
  }, []);

  return (
    <PageWrapper flexDirection="column" minHeight="100vh">
      <Switch>
        {/* Public Routes */}
        <Route
          exact
          path={Paths.start}
          render={() => <Redirect to={{ pathname: isLoggedIn() ? Paths.policies : Paths.login.path }} />}
        />
        <Route exact path={Paths.login.path} component={LoginPage} />

        {/* Private Routes (order is important, most-specific routes first) */}
        <PrivateRoute path={Paths.documents} component={PolicyDocumentsPage} />
        <PrivateRoute path={Paths.modifyPolicy} component={ModifyPolicyPage} />
        <PrivateRoute path={Paths.policies} component={PoliciesPage} />
        <PrivateRoute path={Paths.profile} component={ProfilePage} />

        {/* Page Not Found */}
        <Route component={NotFoundPage} />
      </Switch>
    </PageWrapper>
  );
}

const PageWrapper = styled(Box)`
  /* Disable the text inflation algorithm used on some smartphones and tablets.
     We had an issue on iphone landscape where coverage description font was way too big
     Setting property to 100% instead of none let user zoom */
  text-size-adjust: 100%;
`;
